// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CEjy","right":"styles_right__3LNPA"};